/**
 * Флаг движка таблиц — фаза 3 замены DevExpress-грида (см. REACT_19_PLAN.md).
 *
 * По умолчанию DataTablePage рендерит DataTableV2. Откат на старые движки
 * (dx DataTable / CustomDataTable) — без пересборки, в консоли браузера:
 *   localStorage.setItem('DataTable-Engine', 'legacy'); location.reload();
 * Глобальный откат (для всех пользователей) — поменять DEFAULT_ENGINE ниже
 * на 'legacy' и пересобрать.
 */
const ENGINE_STORAGE_KEY = 'DataTable-Engine';

const DEFAULT_ENGINE = 'v2';

export const isDataTableV2Enabled = (): boolean => {
  try {
    return (localStorage.getItem(ENGINE_STORAGE_KEY) ?? DEFAULT_ENGINE) !== 'legacy';
  } catch {
    // localStorage недоступен (приватный режим/запрет хранилищ) — остаёмся на V2
    return true;
  }
};
